import { fetchList } from "@/api/setting/user";

export default {
    namespaced: true,

    state() {
        return {
            userList: [],
        };
    },

    mutations: {
        setUserList(state, payload) {
            // 为每个用户对象添加 value 属性，其值为用户的 id
            const userListWithValues = payload.map(user => ({
                ...user,
                value: user.id, // 添加 value 属性，值为用户的 id
            }));
            state.userList = Object.freeze(userListWithValues);
        },
    },

    actions: {
        getUserList({ commit }) {
            fetchList({
                pageNum: 1,
                pageSize: 100,
            }).then(res => {
                if (res && Array.isArray(res.list)) {
                    commit('setUserList', res.list);
                }
            });
        },
    },
};